import { Component, input, output } from '@angular/core';
import { DateTime } from 'luxon';
import { NoRecordsComponent } from '@sandbox-platform/shared-ui';

import { CommissionPaymentDTO } from '../../../../types/commission-payment.types';

@Component({
  standalone: true,
  imports: [NoRecordsComponent],
  selector: 'lib-commission-invoice-payment-history',
  templateUrl: './commission-invoice-payment-history.component.html',
})
export class CommissionInvoicePaymentHistoryComponent {
  payments = input.required<CommissionPaymentDTO[]>();
  loading = input<boolean>(false);
  canReversePayment = input<boolean>(false);

  reversePayment = output<string>();

  protected titleCase(value?: string): string {
    if (!value) return '-';
    return value
      .replace(/_/g, ' ')
      .replace(/\w\S*/g, (t) => t.charAt(0).toUpperCase() + t.slice(1));
  }

  protected formatDate(date?: string | Date): string {
    if (!date) return '-';
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    if (Number.isNaN(dateObj.getTime()) || dateObj.getFullYear() <= 1)
      return '-';
    return DateTime.fromJSDate(dateObj).toFormat('dd-MMM-yyyy');
  }

  protected formatMoney(amountMinor?: number, currency = 'KES'): string {
    if (amountMinor === undefined || amountMinor === null) return '-';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
    }).format(amountMinor / 100);
  }
}
